import {booleanAttribute, ChangeDetectionStrategy, Component, input, output, signal} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {fadeInnUtAnimasjon} from "../../animasjoner";
import {KlikkMedStopPropagationDirektiv} from "../../direktiver/klikkMedStopPropagation/klikkMedStopPropagation";

const debug = initDebugger('RopertKomponent');

/**
 * Viser ropert-symbol med en meldingstekst
 */
@Component({
    selector: 'ropert',
    templateUrl: 'ropert.html',
    styleUrl: 'ropert.scss',
    host: {
        '[class.blokk]': 'blokk()',
        '[class]': 'farge()'
    },
    animations: [fadeInnUtAnimasjon('0.5s')],
    imports: [
        KlikkMedStopPropagationDirektiv
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RopertKomponent {

    vedSkjul = output();

    /** Normalt vises ropert som absolutt posisjonert, med blokk=true vises elementet som block */
    blokk= input(false, {transform: booleanAttribute});
    /** Normalt vises ropert med blå bakgrunn, med farge=rød brukes rød bakgrunn */
    farge= input<'rød'|''>('');

    skjult = signal(false);

    constructor() {
    }

    skjul() {
        this.skjult.set(true);
        this.vedSkjul.emit();
    }
}
